import React from 'react';

const ParagraphOptions = ({ editor }) => {
  return (
    <div className="paragraphOptions">
      <h3>Paragraph</h3>
      {/* Options will be added later */}
    </div>
  );
};

export default ParagraphOptions;
